import { onMount } from "solid-js";
import * as styles from "./css/DeathScreen.module.css";
import { Button, Container, Backdrop, Heading } from "@gui/components";
import { PointerLockControls } from "@controllers/controls";
const DeathScreen = () => {
    /**
     * Reload the page.
     * @todo rework the functionality, have it reset the game to a starting state or respawn, potentially with penalty.
     */
    const respawn = () => {
        window.location.reload();
    };
    onMount(() => {
        const controler = PointerLockControls.getInstance();
        controler.unlock();
    });
    return (<Backdrop centered dark>
            <Container>
                <Heading class={styles.heading}>You died</Heading>
                <Button name="respawn" onClick={respawn}>
                    Respawn
                </Button>
            </Container>
        </Backdrop>);
};
export default DeathScreen;
